<script lang="ts">
    import { fade } from 'svelte/transition'
    import { Router, router, Route, Link, navigateTo } from 'yrv'
    import Login from './components/account/users/loginPage.svelte'
    import OAuthAuthorizePage from './components/account/users/oauth-authorize-page.svelte'
    import TemplateMaster from './components/_common/template-master.svelte'
    import PrivateRoute from './components/_common/PrivateRoute.svelte'
    import Pipeline from './components/pipeline/pipes.svelte'
    import Account from './components/account/account.svelte'
    import AccountCompanySelect from './components/account/companies/CompanySelectPage.svelte'
    import Nps from './components/nps/nps.svelte'
    import Agenda from './components/agenda/agenda.svelte'
    import NpsForm from './components/public/nps-form.svelte'
    import Error from './components/_common/error.svelte'
    import AgendaForm from './components/public/agenda-form.svelte'
    import Pos from './components/pos/pos.svelte'
    import SignupPage from './components/account/users/signupPage.svelte'
    import Onboarding from './components/onboarding/onboarding.svelte'
    import Referral from './components/referral/referral.svelte'
    import Dashboard from './components/dashboard/dashboard.svelte'
    import DashboardV2 from './components/dashboard-v2/dashboard.svelte'
    import Docs from './components/tools/docs/docs.svelte'
    import System from './components/tools/system/system.svelte'
    import Prospect from './components/prospect/prospect.svelte'
    import TemplateMobile from './components/_common/template-mobile.svelte'
    import Financial from './components/financial/financial.svelte'
    import Alert from './components/_common/alert.svelte'
    import Stock from './components/stock/stock.svelte'
import StockV2 from './components/stock-v2/stock-v2.svelte'
    import Reports from './components/reports/reports.svelte'
    import ReportsV2 from './components/reports-v2/reports-v2.svelte'
    import { selectedPersonQuery } from './components/_common/stores'
    import CheckoutPage from './components/public/checkout/checkout-page.svelte'
    import Payments from './components/payments/payments.svelte'
    import UpdateCardPage from './components/public/checkout/update-card-page.svelte'
    import Sites from './components/tools/sites/sites.svelte'
    import Schedulers from './components/account/schedulers/schedulers.svelte'
    import Comissions from './components/comissions/comissions.svelte'
    import { onMount } from 'svelte'
    import Init from './init'
    import ResourcesLock from './components/account/resources-lock/resources-lock.svelte'
    import Automacao from './components/automacao/automacao.svelte'
    import Goalboard from './components/tools/goalboards/goalboard.svelte'
    import UserPersonalize from './components/account/users/user-personalize.svelte'
    import ContentForms from './components/customer-service/customer-service.svelte'
    import CustomerServiceForm from './components/public/customer-service-form.svelte'
    import FormV2FormFill from './components/public/form-v2-form-fill.svelte'
    import FormV2PrintPage from './components/public/form-v2-print-page.svelte'
    import FormV2SignPage from './components/public/form-v2-sign-page.svelte'
    import FormV2SignReportPrintPage from './components/public/form-v2-sign-report-print-page.svelte'
    import FormV2RowSignPage from './components/public/form-v2-row-sign-page.svelte'
    import Debug from './components/_common/debug.svelte'
    import Financial_4 from './components/financial-4/financial-4.svelte'
    import Tags from './components/tags/tags.svelte'
    import PricingTable from './components/public/pricing/pricing-table.svelte'
    import Partners from './components/partners/partners.svelte'
    import Logout from './components/_common/logout.svelte'
    import ReauthPrompt from './components/_common/reauth-prompt.svelte'
    import SharePage from './components/_common/share-page.svelte'
    import Popover from './components/_common/popover.svelte'
    import PersonsProfile from './components/persons/persons-profile.svelte'
    import Mgm from './components/public/mgm/mgm.svelte'
    import SendMessage from './components/_common/send-message.svelte'
    import CustomerBalance from './components/customer-balance/customer-balance.svelte'
    import PopoverWindow from './components/_common/popover-window.svelte'
    import UserRestricted from './components/account/users/user-restricted.svelte'
    import FakeBar from './components/_common/fake-bar.svelte'
    import CustomerServiceV2 from './components/customer-service-v2/customer-service-v2.svelte'
    import CsV2Forms from './components/customer-service-v2/forms/cs-v2-forms.svelte'
    import { navKeyForPath } from './modules/usersApi/statistics/statistics-nav-keys'
    import { can } from './modules/infra/permissions'

    let showBar = false
    let loaded = false
    let TemplateSelected
    let current = ''
    let paramsPersons = null

    let allowedHour = true

    onMount(async () => {
        showBar = true // window.store?.user?.userId ? true : false
        await Init.init()
        showBar = window.store?.user?.userId ? true : false
        if (await window.api.utils.utils.isMobile()) {
            TemplateSelected = TemplateMobile
        } else {
            TemplateSelected = TemplateMaster
        }

        // subscreve para pegar o selectedPersonQuery (apenas para mobile).
        // fica aqui, e não no template-mobile, pois deve ser carregado depois do Init.init()
        if (await window.api.utils.utils.isMobile()) {
            selectedPersonQuery.subscribe((value) => {
                if (!value || (!value.act && !value.query)) {
                    paramsPersons = null
                    return
                }
                paramsPersons = value
            })
        }

        loaded = true
        setTimeout(checkAllowLogin, 100)
        setTimeout(() => (showBar = false), 500)
        //
        // registra o módulo mais recente da rota atual no máximo 1x por sessão (dedupe fica no
        // StatisticsService) — dá o "quais módulos foram abertos nesta sessão", não pageviews.
        router.subscribe((state) => {
            const key = navKeyForPath(state?.path)
            if (key) window.api.users.statistics.tickOnce(key)
        })
    })

    async function checkAllowLogin() {
        if (window.store?.user?.userId) {
            try {
                const allows = await window.api.users.companies.getAllowLogin(window.store.user.userId)
                if (allows) {
                    allowedHour = allows.allowLoginNow
                }
            } catch (error) {}
        }
    }

    function goClosePerson() {
        selectedPersonQuery.set(null)
    }

    let printing = false
    function goPrinting(ev) {
        printing = ev.detail
    }
</script>

<SharePage on:printing={goPrinting}></SharePage>
<div class:printing class="class-print">
    {#if loaded}
        <Error />
        <Alert />
        <Logout />
        <ReauthPrompt />
        {#if window.api?.users?.auth?.isValid()}
            <SendMessage />
            <PopoverWindow />
        {/if}
        {#if can('persons.show') && paramsPersons}
            <Popover title="Pessoas" on:close={goClosePerson} width="100%">
                <PersonsProfile params={paramsPersons} on:close={goClosePerson} />
            </Popover>
        {/if}
        <Router>
            <Route path="/public/nps">
                <NpsForm />
            </Route>
            <Route path="/public/mgm">
                <Mgm></Mgm>
            </Route>
            <Route path="/public/share"></Route>

            <Route path="/public/agenda">
                <AgendaForm />
            </Route>

            <Route path="/public/checkout">
                <CheckoutPage />
            </Route>
            <Route path="/public/checkout-card">
                <UpdateCardPage />
            </Route>

            <Route path="/public/pricing">
                <PricingTable></PricingTable>
            </Route>

            <Route path="/public/customer-service">
                <CustomerServiceForm></CustomerServiceForm>
            </Route>

            <Route path="/public/forms-v2/print">
                <FormV2PrintPage></FormV2PrintPage>
            </Route>
            <Route path="/public/forms-v2/assinar">
                <FormV2SignPage></FormV2SignPage>
            </Route>
            <Route path="/public/forms-v2/sign-row">
                <FormV2RowSignPage></FormV2RowSignPage>
            </Route>
            <Route path="/public/forms-v2/relatorio">
                <FormV2SignReportPrintPage></FormV2SignReportPrintPage>
            </Route>
            <Route path="/public/forms-v2">
                <FormV2FormFill></FormV2FormFill>
            </Route>

            {#if !location.href.includes('public/')}
                <Route path="/login">
                    <Login />
                </Route>

                <Route path="/oauth/authorize">
                    <OAuthAuthorizePage />
                </Route>

                <Route exact path="/signup">
                    <SignupPage />
                </Route>

                {#if window.api.users.auth.isValid()}
                    {#if allowedHour}
                        <PrivateRoute exact path="/companies/select">
                            <AccountCompanySelect />
                        </PrivateRoute>

                        {#if !current.includes('/login') && !current.includes('/printer') && !location.href.includes('/companies/select') && !current.includes('/oauth/authorize')}
                            <svelte:component this={TemplateSelected}>
                                <PrivateRoute exact path="/" />

                                <PrivateRoute path="/onboarding">
                                    <Onboarding />
                                </PrivateRoute>

                                <PrivateRoute path="/debug">
                                    <Debug></Debug>
                                </PrivateRoute>

                                {#if can('dashboard.show')}
                                    <!-- <PrivateRoute path="/dashboard">
                                        <Dashboard />
                                    </PrivateRoute> -->
                                    <PrivateRoute path="/dashboard">
                                        <DashboardV2 />
                                    </PrivateRoute>
                                {/if}

                                {#if can('scheduler.show')}
                                    <PrivateRoute path="/agenda">
                                        <Agenda />
                                    </PrivateRoute>
                                {/if}

                                {#if can('pos.show')}
                                    <PrivateRoute path="/pos">
                                        <Pos />
                                    </PrivateRoute>
                                {/if}
                                {#if can('pay.show')}
                                    <PrivateRoute path="/payments">
                                        <Payments />
                                    </PrivateRoute>
                                {/if}

                                {#if can('financial.show')}
                                    <PrivateRoute path="/financial">
                                        <Financial />
                                    </PrivateRoute>

                                    <PrivateRoute path="/financial-4">
                                        <Financial_4></Financial_4>
                                    </PrivateRoute>
                                {/if}

                                {#if can('marketing.show')}
                                    <PrivateRoute path="/automation">
                                        <Automacao />
                                    </PrivateRoute>
                                {/if}

                                {#if can('referral.show')}
                                    <PrivateRoute path="/referral">
                                        <Referral />
                                    </PrivateRoute>
                                {/if}

                                {#if can('balance.show')}
                                    <PrivateRoute path="/customer-balance">
                                        <CustomerBalance></CustomerBalance>
                                    </PrivateRoute>
                                {/if}

                                {#if can('nps.show')}
                                    <PrivateRoute path="/nps">
                                        <Nps />
                                    </PrivateRoute>
                                {/if}

                                {#if can('tags.show')}
                                    <PrivateRoute path="/tags">
                                        <Tags></Tags>
                                    </PrivateRoute>
                                {/if}

                                {#if can('pipeline.show')}
                                    <PrivateRoute path="/pipeline">
                                        <Pipeline />
                                    </PrivateRoute>
                                {/if}

                                {#if can('stock.show')}
                                    <PrivateRoute path="/stock">
                                        <Stock />
                                    </PrivateRoute>
                                    <PrivateRoute path="/stock-v2">
                                        <StockV2 />
                                    </PrivateRoute>
                                {/if}

                                {#if can('reports.show')}
                                    <PrivateRoute path="/reports">
                                        <Reports />
                                    </PrivateRoute>
                                {/if}

                                {#if can('reports.show')}
                                    <PrivateRoute path="/reports-v2">
                                        <ReportsV2 />
                                    </PrivateRoute>
                                {/if}

                                {#if can('tools.docs.read')}
                                    <PrivateRoute path="/documents">
                                        <Docs />
                                    </PrivateRoute>
                                {/if}

                                {#if can('customerService.show')}
                                    <PrivateRoute path="/customer-service">
                                        <ContentForms></ContentForms>
                                    </PrivateRoute>
                                    <PrivateRoute exact path="/resources/customer-service-v2">
                                        <CustomerServiceV2></CustomerServiceV2>
                                    </PrivateRoute>
                                    <PrivateRoute path="/customer-service-v2/forms">
                                        <CsV2Forms></CsV2Forms>
                                    </PrivateRoute>
                                {/if}

                                <PrivateRoute path="/prospect">
                                    <Prospect />
                                </PrivateRoute>

                                <PrivateRoute path="/resources">
                                    <Account />
                                </PrivateRoute>

                                <PrivateRoute path="/tools-scheduler">
                                    <Schedulers />
                                </PrivateRoute>
                                <PrivateRoute path="/tools-app">
                                    <Sites />
                                </PrivateRoute>
                                {#if can('goals.show')}
                                    <PrivateRoute path="/tools-goalboard">
                                        <Goalboard />
                                    </PrivateRoute>
                                {/if}

                                <PrivateRoute path="/resources-lock">
                                    <ResourcesLock />
                                </PrivateRoute>

                                {#if can('comissions.show')}
                                    <PrivateRoute path="/comissions">
                                        <Comissions />
                                    </PrivateRoute>
                                {/if}
                                {#if can('partnership.show')}
                                    <PrivateRoute path="/partners">
                                        <Partners></Partners>
                                    </PrivateRoute>
                                {/if}

                                <PrivateRoute path="/personalize">
                                    <UserPersonalize />
                                </PrivateRoute>
                                <PrivateRoute path="/system">
                                    <System></System>
                                </PrivateRoute>
                            </svelte:component>
                        {/if}
                    {:else}
                        <PrivateRoute path="/">
                            <UserRestricted></UserRestricted>
                        </PrivateRoute>
                    {/if}
                {/if}
            {/if}
        </Router>
    {/if}

    {#if showBar}
        <div class="-loading" in:fade={{ duration: 100 }} out:fade={{ duration: 400 }}>
            <div class="-loading-in">
                <FakeBar></FakeBar>
            </div>
        </div>
    {/if}
</div>

<style>
    .printing {
        display: none !important;
    }

    .-loading {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 32px;
        min-height: 70vh;
        z-index: 99999;
        position: absolute;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        backdrop-filter: blur(3px);
        background-color: #77777745;
    }
    .-loading-in {
        flex: 1 1 360px;
        max-width: 360px;
        padding: 32px 8px;
    }
</style>
